// @flow

class SignProcessDocument {
  fileType: string;
  name: string;
  approved: boolean;
  rejected: boolean;
  message: ?string;

  static parseList(raw?: any): SignProcessDocument[] {
    let list: SignProcessDocument[] = [];
    if (raw && Array.isArray(raw)) {
      for (let item of raw) {
        const file: ?SignProcessDocument = SignProcessDocument.parse(item);
        if (file) {
          list.push(file);
        }
      }
    }
    return list;
  }

  static parse(raw: any): ?SignProcessDocument {
    if (raw) {
      let file: SignProcessDocument = new SignProcessDocument();
      file.fileType = raw.fileType;
      file.name = raw.name;
      file.approved = raw.approved;
      file.rejected = raw.rejected;
      file.message = raw.message;
      return file;
    }
  }
}

export default SignProcessDocument;
